let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bV8sS")).then(() => parcelRequire('dU88R'));